// extracted by mini-css-extract-plugin
export default {"externalLink":"ExternalLink_externalLink__20hOZ","externalIcon":"ExternalLink_externalIcon__PhqAk"};